import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { usePermissions } from "@/hooks/usePermissions";
import config from "@/config/environment";

const HomePage = () => {
  const { user } = useAuth();
  const { isAdmin, cashOutPermissions } = usePermissions();

  return (
    <div>
      {/* Page Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-500 dark:text-white">
          Welcome, {user?.firstName || "User"}!
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1">
          {config.app.tagline}
        </p>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="card">
          <h2 className="card-title mb-4">Cash Outs</h2>
          <p className="text-gray-500 dark:text-gray-400 mb-4">
            Manage daily cash out entries and reconciliation.
          </p>
          <div className="space-y-3">
            <Link
              to="/cash-outs"
              className="block w-full btn-primary text-center"
            >
              View Cash Outs
            </Link>
            {cashOutPermissions.canCreate && (
              <Link
                to="/cash-outs/create"
                className="block w-full btn-secondary text-center"
              >
                Add New Cash Out
              </Link>
            )}
          </div>
        </div>

        {isAdmin && (
          <div className="card">
            <h2 className="card-title mb-4">User Management</h2>
            <p className="text-gray-500 dark:text-gray-400 mb-4">
              Manage restaurant staff and user accounts.
            </p>
            <div className="space-y-3">
              <Link
                to="/users"
                className="block w-full btn-primary text-center"
              >
                View Users
              </Link>
              <Link
                to="/users/create"
                className="block w-full btn-secondary text-center"
              >
                Add New User
              </Link>
            </div>
          </div>
        )}

        <div className="card">
          <h2 className="card-title mb-4">Account</h2>
          <p className="text-gray-500 dark:text-gray-400 mb-4">
            Manage your profile and account settings.
          </p>
          <div className="space-y-3">
            <Link
              to="/profile"
              className="block w-full btn-primary text-center"
            >
              View Profile
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
